import { render, staticRenderFns } from "./LeftBottom.vue?vue&type=template&id=3ef0df38&scoped=true"
import script from "./LeftBottom.vue?vue&type=script&lang=js"
export * from "./LeftBottom.vue?vue&type=script&lang=js"
import style0 from "./LeftBottom.vue?vue&type=style&index=0&id=3ef0df38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef0df38",
  null
  
)

export default component.exports